import type { DocumentCommentModel } from "@/api/cle-api";
import {
  DocumentAuditTrailActionLabels,
  DocumentAuditTrailModel,
} from "@/api/cle-api/models/documents";

export const formatDate = (date: string | null | undefined) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("da-DK");
};

export const formatDateLong = (date: string | null | undefined) => {
  if (!date) return "-";
  return new Date(date).toLocaleDateString("da-DK", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
};

export const formatDateTime = (date: string | null | undefined) => {
  if (!date) return "-";
  return new Date(date).toLocaleString("da-DK", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const formatOverfoertTilPeriode = (
  fra?: string | null,
  til?: string | null,
  fallbackId?: string | null,
) => {
  if (fra && til) {
    return `${formatDate(fra)} – ${formatDate(til)}`;
  }
  if (fallbackId) return fallbackId;
  return "-";
};

export const formatBoolean = (value: boolean | null) => {
  if (value === null) return "-";
  return value ? "Ja" : "Nej";
};

export const formatAuditTrailAction = (item: DocumentAuditTrailModel) =>
  item.action ? DocumentAuditTrailActionLabels[item.action] : "Hændelse";

export const formatAuditTrailActor = (item: DocumentAuditTrailModel) =>
  item.actorDisplayName ?? "Ai";

export const formatCommentAuthor = (item: DocumentCommentModel) =>
  item.createdByName ?? item.actorDisplayName ?? item.createdBy ?? "Ukendt";

export const formatAmount = (value: number | null | undefined) => {
  if (value == null) return "-";
  return value.toLocaleString("da-DK");
};
